import * as React from "react";
import { cn } from "../utils/cn";

export type BadgeVariant =
  | "default"
  | "secondary"
  | "success"
  | "outline"
  | "destructive";

export default function Badge({
  children,
  className,
  variant = "default",
}: {
  children: React.ReactNode;
  className?: string;
  variant?: BadgeVariant;
}) {
  const variants: Record<BadgeVariant, string> = {
    default: "bg-muted text-fg border border-border",
    secondary: "bg-card-2 text-fg/80 border border-border/60",
    success: "bg-primary/15 text-[var(--kw-primary-fg)] border border-primary/25",
    outline: "bg-transparent text-fg border border-border",
    destructive: "bg-danger/15 text-danger border border-danger/25",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 h-6 px-2.5 rounded-full text-[11px] font-medium",
        "transition-colors",
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
